import type { Object3D } from 'three';

/**
 * Check if an object is an interface element (should not be wireframed)
 * Interface elements include: light helpers, camera helpers, debug visualizations
 */
export const isInterfaceObject = (object: Object3D): boolean => {
	const name = object.name || '';

	// Check by name prefix
	if (
		name.startsWith('debug_') ||
		name.startsWith('light_helper') ||
		name.startsWith('camera_helper') ||
		name.startsWith('highlight-') ||
		name.startsWith('transition-arc') ||
		name.startsWith('front-face') ||
		name.startsWith('top-face') ||
		name.includes('Helper') ||
		name.includes('helper') ||
		(name.includes('Sphere') && name.includes('debug')) ||
		name.includes('circle') ||
		name.includes('Circle')
	) {
		return true;
	}

	// Check by userData flag
	if (object.userData?.isInterface === true) {
		return true;
	}

	// Check by type
	if (object.userData?.type === 'debugVisualization' || object.userData?.type === 'helper') {
		return true;
	}

	return false;
};
